import { LayoutType, withLayout } from 'src/hocs/withLayout'

import { CarePartner } from './CarePartner'

const WrappedCarePartner = withLayout(LayoutType.Default, CarePartner)

export { WrappedCarePartner as CarePartner }
